export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20sports%20atmosphere%20with%20warm%20orange%20and%20dark%20gradient%20tones%2C%20athletic%20energy%20flow%20lines%2C%20modern%20stadium%20light%20effects%2C%20digital%20data%20particles%20floating%2C%20dramatic%20sports%20lighting%2C%20professional%20sports%20photography%20aesthetic%2C%20high%20contrast%2C%20cinematic%20mood&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="大满贯APP - 专业体育赛事平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
          <i className="ri-android-line text-primary-400 text-sm"></i>
          <span className="text-primary-300 text-sm font-medium">安卓正版 · 官方直装</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
          大满贯APP安卓版
          <br />
          <span className="text-primary-400">专业赛事 一触即达</span>
        </h1>

        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          海量赛事直播、实时数据分析、精准赛事预测。支持安卓全机型，一键安装极速体验，让您随时随地掌握体育世界的每一个精彩瞬间。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer group"
          >
            <i className="ri-download-2-line text-lg group-hover:translate-y-0.5 transition-transform"></i>
            立即下载 APK
          </a>
          <a
            href="#features"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl border border-white/30 text-white text-base font-medium hover:bg-white/10 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-white/50 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-accent-400"></i>
            <span>安全无毒</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-smartphone-line text-accent-400"></i>
            <span>全机型适配</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-flashlight-line text-accent-400"></i>
            <span>极速安装</span>
          </div>
        </div>
      </div>
    </section>
  );
}